import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnersComponent } from './spinners.component';

@NgModule({
  declarations: [
    SpinnersComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SpinnersComponent
  ]
})
export class UIASpinnersModule { }
